"use client";

import { useSyncExternalStore } from "react";

const subscribe = (notify: () => void) => {
  window.addEventListener("consent_update", notify);
  return () => window.removeEventListener("consent_update", notify);
};

export default function PrivacyChoices() {
  // GPC is honored unless the visitor explicitly accepted afterwards.
  const gpc = useSyncExternalStore(
    subscribe,
    () => window.privacyConsent?.gpc === true && window.privacyConsent?.allowed !== true,
    () => false
  );
  return (
    <>
      <button
        type="button"
        onClick={() => window.openPrivacyPreferences?.()}
        className="text-left hover:text-primary transition-colors"
      >
        Privacy Choices / Do Not Sell or Share
      </button>
      {gpc && (
        <p role="status" className="mt-2 text-sm text-muted-foreground">
          Global Privacy Control honored. Optional tracking is off.
        </p>
      )}
    </>
  );
}
